import { WorkflowExecutionNode } from '../model';
import { ExecutionNodeStatusEnum, WorkflowExecutionStatusEnum } from 'types';

export const TERMINAL_EXECUTION_STATUSES: ReadonlySet<WorkflowExecutionStatusEnum> = new Set([
  WorkflowExecutionStatusEnum.COMPLETED,
  WorkflowExecutionStatusEnum.FAILED,
  WorkflowExecutionStatusEnum.CANCELLED,
]);

export const TERMINAL_NODE_STATUSES: ReadonlySet<ExecutionNodeStatusEnum> = new Set([
  ExecutionNodeStatusEnum.COMPLETED,
  ExecutionNodeStatusEnum.COMPLETED_WITH_WARNINGS,
  ExecutionNodeStatusEnum.FAILED,
  ExecutionNodeStatusEnum.CANCELLED,
]);

export function computeExecutionProgress(nodes: WorkflowExecutionNode[] | undefined): number {
  if (!nodes || nodes.length === 0) return 0;

  const enabled = nodes.filter((node) => node.status !== ExecutionNodeStatusEnum.DISABLED);
  if (enabled.length === 0) return 0;

  const total = enabled.reduce((sum, node) => {
    if (
      node.status === ExecutionNodeStatusEnum.COMPLETED ||
      node.status === ExecutionNodeStatusEnum.COMPLETED_WITH_WARNINGS
    ) {
      return sum + 1;
    }
    if (node.status === ExecutionNodeStatusEnum.RUNNING) {
      return sum + (node.processed_items_percent ?? 0) / 100;
    }
    return sum;
  }, 0);

  return (total / enabled.length) * 100;
}
